import {Howl} from 'howler';
const ONE_MINUTE_IN_MS = 60000.0;

export class Sound {
    constructor() {
        this.soundManager = null;
        this.soundLoaded = false;
        this.loadSounds();
        this.bpm = 120;
    }

    getSoundLoaded() {
        return this.soundLoaded;
    }

    loadSounds() {

        let guitar_sprite_length = 750;
        let guitar_sprite_start = 0;
        let guitar_sprite_dict = {};
        for (let i = 0; i < 127; i++) {
            guitar_sprite_dict[i.toString(10)] = [guitar_sprite_start, guitar_sprite_length];
            guitar_sprite_start += 1000;
        }

        this.soundManager = new Howl({
            volume: 1.0,
            src: ["/static/fachords3/tools/sounds/0-127.webm", "/static/fachords3/tools/sounds/0-127.mp3", "/static/fachords3/tools/sounds/0-127.ogg", "/static/fachords3/tools/sounds/0-127.m4a"],
            sprite: guitar_sprite_dict
        });

        let self = this;
        this.soundManager.once("load", function () {
            self.soundLoaded = true;
        });

        this.soundManager.volume(120);

    }

    playBeat(midis) {
        //se nota singola diventa lista di uno
        if (!Array.isArray(midis)) {
            midis = [midis]
        }
        midis.forEach(midi => {
            midi = midi.toString(10);
            let sound = this.soundManager.play(midi);
            this.soundManager.fade(100, 0, ONE_MINUTE_IN_MS / this.bpm + 50, sound);
        })
    }
}



